import styled from 'styled-components';
import { CROSS_SELL_VERTICAL_BREAKPOINT } from '../../../../utils/cross-sell';

export const WrapperContainer = styled.section`
  position: relative;
  display: flex;
  gap: 1rem;
`;

export const CartContent = styled.div`
  flex: 1;
  min-width: 0;
`;

export const VerticalCrossSellSidebar = styled.aside`
  min-width: 20rem;
  padding-top: 0;
  padding-left: 1.5625rem;
  ${({ theme }) => `background: ${theme.colors.gray2};`}

  @media (max-width: ${CROSS_SELL_VERTICAL_BREAKPOINT - 1}px) {
    display: none;
  }
`;
